import { useSetAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'

import { dialogInfoAtom } from '../atoms'
import { type DocumentReport } from '../hooks/useArchivedDocumentReportsInfiniteQuery'

export type DeleteButtonProps = {
  documentReport: DocumentReport
}

export const DeleteButton = ({ documentReport }: DeleteButtonProps) => {
  const { t } = useTranslation()
  const setDialogInfo = useSetAtom(dialogInfoAtom)
  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ dialogType: 'delete', documentReport })
  }, [documentReport, setDialogInfo])

  return (
    <StyledButton
      disabled={!documentReport.isDeletable}
      fillMode="outline"
      icon="delete"
      onClick={handleClick}
    >
      {t('delete_forever')}
    </StyledButton>
  )
}
